import React from 'react';
import './DataTableGrid.css';

const DataTableGrid = ({ 
  items = [], 
  loading = false, 
  error = null, 
  columns = [],
  emptyMessage = "No items found",
  onSort,
  sortField,
  getSortIcon
}) => {
  if (loading) {
    return (
      <div className="data-table-loading">
        <div className="loading-text">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="data-table-error">
        <div className="">No Data Found</div>
      </div>
    );
  }

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th 
                key={column.key}
                onClick={() => onSort && onSort(column.sortKey || column.key)}
                style={{ cursor: onSort ? 'pointer' : 'default', userSelect: 'none' }}
              >
                {column.title}
                {getSortIcon && getSortIcon(column.sortKey || column.key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: 'center', padding: '40px', color: '#ffffff' }}>
                {emptyMessage}
              </td>
            </tr>
          ) : (
            items.map((item, index) => (
              <tr key={item.id || index}>
                {columns.map((column) => (
                  <td key={column.key}>
                    {column.render ? column.render(item, index) : item[column.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTableGrid;